import { http } from "shared/api/http";

const apiBase = process.env.REACT_APP_API_BASE_URL;

export interface IInvitation {
  id: string;
  email: string;
  tenantId: string;
  tenantRole: string;
  auth0InvitationId?: string;
  invitedBy?: string;
  status: string;
  createdAt: string;
  expiresAt: string;
  inviter?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email: string;
  };
}

export const inviteUser = async (
  tenantId: string,
  email: string,
  tenantRole: string
): Promise<IInvitation> => {
  const res = await http.post<IInvitation>(
    `${apiBase}/api/v1/tenants/${tenantId}/invitations`,
    { email, tenantRole }
  );
  return res?.data;
};

export const getInvitations = async (
  tenantId: string,
  status?: string
): Promise<IInvitation[]> => {
  const params = status ? `?status=${status}` : "";
  const res = await http.get<IInvitation[]>(
    `${apiBase}/api/v1/tenants/${tenantId}/invitations${params}`
  );
  return res?.data;
};

export const resendInvitation = async (
  tenantId: string,
  invitationId: string
): Promise<IInvitation> => {
  const res = await http.post<IInvitation>(
    `${apiBase}/api/v1/tenants/${tenantId}/invitations/${invitationId}/resend`
  );
  return res?.data;
};

export const revokeInvitation = async (
  tenantId: string,
  invitationId: string
): Promise<IInvitation> => {
  const res = await http.delete<IInvitation>(
    `${apiBase}/api/v1/tenants/${tenantId}/invitations/${invitationId}`
  );
  return res?.data;
};
